<template>
  <div class="wrapper">
    <table class="table-wrapper" width="100%">
      <tr class="head">
        <th class="head-time">时间</th>
        <th class="head-activity">活动</th>
        <th class="head-expend">费用</th>
        <th class="head-link">链接</th>
      </tr>
      <tr class="item" v-for="(item, index) in info['mainData']" :key="item + '&' + index">
        <td class="item-time" v-if="item.time" :rowspan="item.rowspan || 1">{{item.time}}</td>
        <td class="item-activity">{{item.activity}}</td>
        <td class="item-expend">{{item.expend}}</td>
        <td class="item-link">{{item.link}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ['info']
}
</script>

<style lang="scss" scoped>
  @import '@/style/bulma/app.sass';

  .wrapper {
    @include mobile {
      width: 100%;
      overflow: scroll;
    }
  }

  .table-wrapper {
    border: 1px solid rgba(235,217,186,1);
    font-family:PingFang SC;
    border-collapse: collapse;
    @include mobile {
      width: 775px;
    }

    .head {
      width: 100%;
      background: rgba(235, 217, 186, 0.1);
      border: 1px solid rgba(235,217,186,1);
      border-collapse: collapse;

      &>th {
        font-size: 17px;
        font-weight: 500;
        color: rgba(62,64,74,1);
        text-align: center;
        border-collapse: collapse;
        border-bottom: 1px solid rgba(235,217,186,1);

      }

      // .head-time {
      //   display: block;
      //   width: 15%;
      // }
      .head-activity {
        @include mobile {
          width: 200px;
        }
      }
      // .head-expend {
      //   width: 15%;
      //   display: block;
      // }
      // .head-link {
      //   width: 35%;
      //   display: block;
      // }
    }

    .item {
      border: 1px solid rgba(235,217,186,1);
      border-collapse: collapse;

      &:nth-of-type(2n+1) {
        background: rgba(235, 217, 186, 0.1);
      }

      &>td {
        font-size: 12px;
        font-weight: 400;
        color:r gba(74,74,74,1);
        text-align: center;
        vertical-align: middle;
        padding: 12px 15px;
        border: 1px solid rgba(235,217,186,1);
        border-collapse: collapse;
      }

    }
  }
</style>
